var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20_30373)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 82,
    height: 82,
    rx: 41,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 81,
    height: 81,
    rx: 40.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6668 57.9166H33.3335C29.8835 57.9166 27.0835 55.1166 27.0835 51.6666V23.3333C27.0835 22.6499 27.6502 22.0833 28.3335 22.0833C29.0168 22.0833 29.5835 22.6499 29.5835 23.3333V51.6666C29.5835 53.7333 31.2668 55.4166 33.3335 55.4166H61.6668C62.3502 55.4166 62.9168 55.9833 62.9168 56.6666C62.9168 57.3499 62.3502 57.9166 61.6668 57.9166Z",
    fill: "url(#paint0_linear_20_30373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3332 49.5834C33.0499 49.5834 32.7499 49.4834 32.5165 49.2834C31.9999 48.8334 31.9332 48.05 32.3832 47.5167L40.0332 38.5834C40.8665 37.6167 42.0665 37.0334 43.3332 36.9834C44.5999 36.95 45.8499 37.4167 46.7499 38.3167L48.3332 39.9C48.7499 40.3167 49.2999 40.5167 49.8832 40.5167C50.4665 40.5 50.9999 40.2334 51.3832 39.7834L59.0332 30.85C59.4832 30.3334 60.2665 30.2667 60.7999 30.7167C61.3165 31.1667 61.3832 31.95 60.9332 32.4833L53.2832 41.4167C52.4499 42.3834 51.2499 42.9667 49.9832 43.0167C48.7165 43.05 47.4665 42.5834 46.5665 41.6834L44.9999 40.1C44.5832 39.6834 44.0332 39.4667 43.4499 39.4834C42.8665 39.5 42.3332 39.7667 41.9499 40.2167L34.2999 49.15C34.0332 49.4333 33.6832 49.5834 33.3332 49.5834Z",
    fill: "url(#paint1_linear_20_30373)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20_30373",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20_30373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20_30373",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_30373",
    x1: 45.0002,
    y1: 22.0833,
    x2: 45.0002,
    y2: 57.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_30373",
    x1: 46.6582,
    y1: 30.417,
    x2: 46.6582,
    y2: 49.5834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeicon);
export default __webpack_public_path__ + "static/media/tradeicon.3c1b1ca9d1280dbdc2e7b7b278845916.svg";
export { ForwardRef as ReactComponent };